import ProcessInstanceEntityHeader from 'domain/gpo/cockpit/instance/shared/header/ProcessInstanceEntityHeader';

export default ProcessInstanceEntityHeader;
